module.exports = __webpack_public_path__ + "static/media/blueHC.b250db3c.svg";